import { Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PanelCollapse from '../../../../../../../shared/components/collapse/PanelCollapse';
import { FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import { feverDays, GUTTOR_SPACE } from '../../../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../../../store';
import { setIsCovidCase } from '../../../../../../../store/actions/newAdmissionAction';

const CovidCaseCard = ({ isLoading, form }: any): ReactElement => {
  const dispatch = useDispatch();
  const { newAdmission: { isCovidCase } } = useSelector((state: RootState): RootState => state);
  const [activeKey, setActiveKey] = useState<number[]>([]);
  const { newAdmission: {cardCollapse: { isCovidCaseCardOpen } },
  } = useSelector((state: RootState): RootState => state);

  const commonDetail = { isLoading, form };
  useEffect((): void => {
    if (typeof isCovidCaseCardOpen === 'boolean') {
      if (isCovidCaseCardOpen) {
        setActiveKey([1]);
        dispatch(setIsCovidCase(true));
      } else {
        setActiveKey([]);
      }
    }
  }, [isCovidCaseCardOpen]);

  useEffect((): void => {
  }, [isCovidCase]);
  return (
    (isCovidCase) ?
      <PanelCollapse
        activeKey={isCovidCase ? [1] : activeKey}
        keyName="1"
        accordion={true}
        expandIconPosition="right"
        header="Covid Case"
      >
        <Row gutter={GUTTOR_SPACE}>
          <FormSelect detail={{
            ...commonDetail,
            key: 'sinceFeverDays',
            size: 12,
            options: feverDays || [],
            showSearch: true,
            onlyAlphaNumeric: true,
          }} />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'oxygenSaturationLevel',
              size: 12,
            }}
            />
            <FormTextInput detail={{
              ...commonDetail,
              key: 'respiratoryRate',
              size: 12,
            }}
            />
        </Row>
      </PanelCollapse> :
      <React.Fragment />
  );
};

export default withRouter(CovidCaseCard);
